import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

class BanksDAO {

    static async get(countryCode: string, id: string): Promise<RpcResponse> {
        return await RpcService.makeRequest('banks.get', {
            countryCode,
            id
        });
    }
}

export default BanksDAO;
